import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TransitDetailComponent } from './transit-detail.component';

const routes: Routes = [
  {
    path: '',
    component: TransitDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransitDetailComponentRoutingModule {}
